/**
 * SOIE Sleep-Upgrade Landing Page
 * Handles variant selection, AJAX cart, cart drawer, upsell, sticky bar, smooth scroll.
 */
(function () {
  'use strict';

  /* ── Variant Maps ─────────────────────────────────────────────── */
  const PILLOWCASE_VARIANTS = {
    Coffee: 48107022221504,
    Grey: 48107022254272,
    Navy: 48107022287040,
    White: 48107022319808,
  };

  const SHEET_VARIANTS = {
    'Coffee/Queen (230×250cm)': 48107022614720,
    'Coffee/King (245×250cm)': 48107022647488,
    'Navy/Queen (230×250cm)': 48107022680256,
    'Navy/King (245×250cm)': 48107022713024,
    'White/Queen (230×250cm)': 48107022876864,
    'White/King (245×250cm)': 48107022909632,
    'Grey/Queen (230×250cm)': 48107022942400,
    'Grey/King (245×250cm)': 48107022975168,
  };

  const PILLOWCASE_IDS = new Set(Object.values(PILLOWCASE_VARIANTS));
  const SHEET_IDS = new Set(Object.values(SHEET_VARIANTS));

  const PILLOWCASE_TO_SHEET = {};
  Object.keys(PILLOWCASE_VARIANTS).forEach(function (color) {
    PILLOWCASE_TO_SHEET[PILLOWCASE_VARIANTS[color]] = SHEET_VARIANTS[color + '/Queen (230×250cm)'];
  });

  /* ── Variant Image Maps (theme asset filenames) ──────────────── */
  const PILLOWCASE_IMAGES = {
    Coffee: 'pillowcase-coffee.webp',
    Grey: 'pillowcase-grey.webp',
    Navy: 'pillowcase-navy.webp',
    White: 'pillowcase-white.webp',
  };
  const SHEET_IMAGES = {
    Coffee: 'sheet-coffee.webp',
    Grey: 'sheet-grey.webp',
    Navy: 'sheet-navy.webp',
    White: 'sheet-white.webp',
  };

  /* ── Helpers ──────────────────────────────────────────────────── */
  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    }).then(function (r) { return r.json(); });
  }

  function getCart() {
    return fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  var cartCurrencyCode = 'USD';

  /* Publish Shopify analytics event so TikTok / Meta pixels pick it up */
  function publishAnalytics(event, payload) {
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(event, payload);
      }
    } catch (e) { /* swallow */ }
  }

  function publishAddToCart(item) {
    if (!item) return;
    var price = (item.final_price != null ? item.final_price : item.price) || 0;
    var lineTotal = item.final_line_price != null ? item.final_line_price : (price * (item.quantity || 1));
    publishAnalytics('product_added_to_cart', {
      cartLine: {
        cost: {
          totalAmount: { amount: lineTotal / 100, currencyCode: cartCurrencyCode },
        },
        merchandise: {
          id: 'gid://shopify/ProductVariant/' + (item.variant_id || item.id),
          price: { amount: price / 100, currencyCode: cartCurrencyCode },
          title: item.variant_title || '',
          product: {
            id: 'gid://shopify/Product/' + item.product_id,
            title: item.product_title || item.title || '',
            type: item.product_type || '',
            vendor: item.vendor || 'SŌIE',
            url: item.url || ('/products/' + (item.handle || '')),
          },
        },
        quantity: item.quantity || 1,
      },
    });
  }

  function publishProductViewed(handle, variantId, price) {
    publishAnalytics('product_viewed', {
      productVariant: {
        id: 'gid://shopify/ProductVariant/' + variantId,
        price: { amount: price, currencyCode: cartCurrencyCode },
        product: {
          id: '',
          title: handle,
          url: '/products/' + handle,
          vendor: 'SŌIE',
        },
      },
    });
  }

  function money(cents) {
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: cartCurrencyCode,
      }).format((cents || 0) / 100);
    } catch (e) {
      return '$' + ((cents || 0) / 100).toFixed(2);
    }
  }

  /* ── 1. Variant Selectors ─────────────────────────────────────── */
  function getSelectedColor(product) {
    var el = document.querySelector('.soie-swatch[data-product="' + product + '"].active');
    return el ? el.dataset.color : null;
  }

  function getSelectedSize(product) {
    var el = document.querySelector('.soie-size-pill[data-product="' + product + '"].active');
    return el ? el.dataset.size : null;
  }

  function updatePillowcaseVariant() {
    var color = getSelectedColor('pillowcase');
    if (!color) return;
    var id = PILLOWCASE_VARIANTS[color];
    var btn = document.querySelector('.soie-atc-btn[data-product="pillowcase"]');
    if (btn && id) btn.dataset.variantId = id;
  }

  function updateSheetVariant() {
    var color = getSelectedColor('sheet');
    var size = getSelectedSize('sheet');
    if (!color || !size) return;
    var id = SHEET_VARIANTS[color + '/' + size];
    var btn = document.querySelector('.soie-atc-btn[data-product="sheet"]');
    if (btn && id) btn.dataset.variantId = id;
  }

  function initSwatches() {
    document.querySelectorAll('.soie-swatch').forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        var product = this.dataset.product;
        document.querySelectorAll('.soie-swatch[data-product="' + product + '"]')
          .forEach(function (s) { s.classList.remove('active'); });
        this.classList.add('active');
        if (product === 'pillowcase') {
          updatePillowcaseVariant();
          swapHeroImage('pillowcase', this.dataset.color);
        }
        if (product === 'sheet') {
          updateSheetVariant();
          swapHeroImage('sheet', this.dataset.color);
        }
        if (product === 'bundle') {
          updateBundlePreview(this.dataset.color);
        }
      });
    });

    document.querySelectorAll('.soie-size-pill').forEach(function (pill) {
      pill.addEventListener('click', function () {
        var product = this.dataset.product;
        document.querySelectorAll('.soie-size-pill[data-product="' + product + '"]')
          .forEach(function (p) { p.classList.remove('active'); });
        this.classList.add('active');
        updateSheetVariant();
      });
    });
  }

  /* ── 2. Cart Drawer ───────────────────────────────────────────── */
  var drawerBuilt = false;
  var overlay, drawer, itemsContainer, upsellContainer, subtotalEl;

  function buildDrawer() {
    if (drawerBuilt) return;
    drawerBuilt = true;

    overlay = document.createElement('div');
    overlay.className = 'soie-cart-overlay';
    document.body.appendChild(overlay);

    drawer = document.createElement('div');
    drawer.className = 'soie-cart-drawer';
    drawer.innerHTML =
      '<div class="soie-cart-header">' +
        '<span>YOUR CART</span>' +
        '<button class="soie-cart-close">\u00d7</button>' +
      '</div>' +
      '<div class="soie-cart-items"></div>' +
      '<div class="soie-cart-upsell"></div>' +
      '<div class="soie-cart-footer">' +
        '<div class="soie-cart-subtotal"></div>' +
        '<a href="/checkout" class="soie-cart-checkout">PROCEED TO CHECKOUT</a>' +
        '<button class="soie-cart-continue">\u2190 Continue Shopping</button>' +
      '</div>';
    document.body.appendChild(drawer);

    itemsContainer = drawer.querySelector('.soie-cart-items');
    upsellContainer = drawer.querySelector('.soie-cart-upsell');
    subtotalEl = drawer.querySelector('.soie-cart-subtotal');

    drawer.querySelector('.soie-cart-close').addEventListener('click', closeDrawer);
    drawer.querySelector('.soie-cart-continue').addEventListener('click', closeDrawer);
    overlay.addEventListener('click', closeDrawer);
  }

  function openDrawer() {
    buildDrawer();
    getCart().then(renderDrawer);
    drawer.classList.add('open');
    overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('open');
    overlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  function renderDrawer(cart) {
    /* Update currency from cart */
    if (cart && cart.currency) cartCurrencyCode = cart.currency;
    /* Items */
    if (cart.items.length === 0) {
      itemsContainer.innerHTML = '<p style="padding:1rem;text-align:center;">Your cart is empty.</p>';
    } else {
      itemsContainer.innerHTML = cart.items.map(function (item) {
        return (
          '<div class="soie-cart-item" data-key="' + item.key + '">' +
            '<img class="soie-cart-item-img" src="' + (item.image || '') + '" alt="' + item.title + '">' +
            '<div class="soie-cart-item-info">' +
              '<div class="soie-cart-item-title">' + item.product_title + '</div>' +
              '<div class="soie-cart-item-variant">' + item.variant_title + '</div>' +
              '<div class="soie-cart-item-price">' + money(item.final_line_price) + '</div>' +
              '<div class="soie-cart-item-qty">' +
                '<button class="soie-qty-btn soie-qty-minus" data-key="' + item.key + '" data-qty="' + (item.quantity - 1) + '">\u2212</button>' +
                '<span>' + item.quantity + '</span>' +
                '<button class="soie-qty-btn soie-qty-plus" data-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '">+</button>' +
              '</div>' +
              '<a href="#" class="soie-cart-item-remove" data-key="' + item.key + '">Remove</a>' +
            '</div>' +
          '</div>'
        );
      }).join('');
    }

    /* Subtotal */
    subtotalEl.textContent = 'Subtotal: ' + money(cart.total_price);

    /* Inject cart reservation timer */
    if (typeof injectCartReservation === 'function') injectCartReservation();

    /* Qty buttons */
    itemsContainer.querySelectorAll('.soie-qty-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        changeQty(this.dataset.key, parseInt(this.dataset.qty, 10));
      });
    });

    /* Remove links */
    itemsContainer.querySelectorAll('.soie-cart-item-remove').forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        changeQty(this.dataset.key, 0);
      });
    });

    /* Upsell logic */
    renderUpsell(cart);
  }

  function changeQty(key, qty) {
    postJSON('/cart/change.js', { id: key, quantity: qty })
      .then(function () { return getCart(); })
      .then(renderDrawer);
  }

  /* ── 3. Upsell ────────────────────────────────────────────────── */
  function renderUpsell(cart) {
    var onlyPillowcase = cart.items.length > 0 &&
      cart.items.every(function (i) { return PILLOWCASE_IDS.has(i.variant_id); }) &&
      !cart.items.some(function (i) { return SHEET_IDS.has(i.variant_id); });

    if (!onlyPillowcase) {
      upsellContainer.innerHTML = '';
      upsellContainer.style.display = 'none';
      return;
    }

    var pillowcaseId = cart.items[0].variant_id;
    var sheetId = PILLOWCASE_TO_SHEET[pillowcaseId] || SHEET_VARIANTS['White/Queen (230×250cm)'];

    upsellContainer.style.display = '';
    upsellContainer.innerHTML =
      '<div class="soie-upsell-inner">' +
        '<p>Add the full sheet set and save</p>' +
        '<button class="soie-upsell-btn" data-sheet-id="' + sheetId + '">Upgrade</button>' +
      '</div>';

    upsellContainer.querySelector('.soie-upsell-btn').addEventListener('click', function () {
      var id = parseInt(this.dataset.sheetId, 10);
      postJSON('/cart/add.js', { items: [{ id: id, quantity: 1 }] })
        .then(function (resp) {
          var items = resp && resp.items ? resp.items : (Array.isArray(resp) ? resp : []);
          items.forEach(publishAddToCart);
          return getCart();
        })
        .then(renderDrawer);
    });
  }

  /* ── 3b. Bundle Preview ───────────────────────────────────────── */
  function updateBundlePreview(color) {
    var filename = SHEET_IMAGES[color];
    if (!filename) return;
    var img = document.getElementById('bundle-preview-img');
    if (!img) return;
    var label = document.getElementById('bundle-color-name');
    if (label) label.textContent = color;

    var currentSrc = img.src;
    var basePath = currentSrc.substring(0, currentSrc.lastIndexOf('/') + 1);
    var newSrc = basePath + filename;
    var qIdx = currentSrc.indexOf('?');
    if (qIdx > -1) newSrc += currentSrc.substring(qIdx);

    img.style.opacity = '0.5';
    img.style.transition = 'opacity 0.3s';
    var temp = new Image();
    temp.onload = function () { img.src = newSrc; img.alt = 'SŌIE bundle in ' + color; img.style.opacity = '1'; };
    temp.onerror = function () { img.style.opacity = '1'; };
    temp.src = newSrc;
  }

  /* ── 3c. Swap Hero Image on Color Change ─────────────────────── */
  function swapHeroImage(product, color) {
    var imageMap = product === 'pillowcase' ? PILLOWCASE_IMAGES : SHEET_IMAGES;
    var filename = imageMap[color];
    if (!filename) return;

    /* Find the hero image in the product's section */
    var sectionId = product === 'pillowcase' ? '#pillowcase-atc' : '#sheet-atc';
    var btn = document.querySelector(sectionId);
    if (!btn) return;
    var section = btn.closest('section') || btn.closest('.section');
    if (!section) return;
    var img = section.querySelector('.soie-landing-hero__image img, .soie-upgrade__image img');
    if (!img) return;

    /* Build the asset URL — Shopify asset URLs follow a predictable pattern */
    var currentSrc = img.src;
    var basePath = currentSrc.substring(0, currentSrc.lastIndexOf('/') + 1);
    /* Strip any query params and cache busters from the filename */
    var newSrc = basePath + filename;
    /* Use the same query params as original */
    var qIdx = currentSrc.indexOf('?');
    if (qIdx > -1) newSrc += currentSrc.substring(qIdx);

    img.style.opacity = '0.5';
    img.style.transition = 'opacity 0.3s';
    var tempImg = new Image();
    tempImg.onload = function () {
      img.src = newSrc;
      img.style.opacity = '1';
    };
    tempImg.onerror = function () {
      img.style.opacity = '1'; /* revert if image doesn't exist */
    };
    tempImg.src = newSrc;
  }

  /* ── 4. AJAX Add to Cart ──────────────────────────────────────── */
  function initATC() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.soie-atc-btn');
      if (!btn) return;
      e.preventDefault();

      /* Start cart reservation timer on first add */
      if (typeof startCartReservation === 'function') startCartReservation();

      var origText = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding...';

      /* Bundle: add both pillowcase + sheet set in matching color */
      if (btn.dataset.bundle === 'true') {
        var bundleColor = getSelectedColor('bundle') || 'White';
        var pillowId = PILLOWCASE_VARIANTS[bundleColor];
        var sheetId = SHEET_VARIANTS[bundleColor + '/Queen (230×250cm)'];

        postJSON('/cart/add.js', {
          items: [
            { id: pillowId, quantity: 1 },
            { id: sheetId, quantity: 1 },
          ],
        })
          .then(function (resp) {
            /* Publish analytics events for each item added */
            var items = resp && resp.items ? resp.items : (Array.isArray(resp) ? resp : []);
            items.forEach(publishAddToCart);
            btn.disabled = false;
            btn.textContent = origText;
            openDrawer();
          })
          .catch(function () {
            btn.disabled = false;
            btn.textContent = origText;
          });
        return;
      }

      /* Single product */
      var variantId = parseInt(btn.dataset.variantId, 10);
      if (!variantId) { btn.disabled = false; btn.textContent = origText; return; }

      postJSON('/cart/add.js', { items: [{ id: variantId, quantity: 1 }] })
        .then(function (resp) {
          /* Publish analytics event for tracked pixels (TikTok, Meta, etc.) */
          var items = resp && resp.items ? resp.items : (Array.isArray(resp) ? resp : []);
          items.forEach(publishAddToCart);
          btn.disabled = false;
          btn.textContent = origText;
          openDrawer();
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = origText;
        });
    });
  }

  /* ── 5. Sticky Mobile Bar ─────────────────────────────────────── */
  function initStickyBar() {
    var target = document.querySelector('.soie-atc-btn[data-product="pillowcase"]');
    var guarantee = document.querySelector('.soie-guarantee');
    if (!target) return;

    var bar = document.createElement('div');
    bar.className = 'soie-sticky-bar';
    /* Pull current price from the ATC button text (e.g. "ADD TO CART — A$54.99") */
    var btnText = target.textContent || '';
    var priceMatch = btnText.match(/[\u20AC\u00A3$][^\s]+/);
    var displayPrice = priceMatch ? priceMatch[0] : '';
    bar.innerHTML =
      '<div class="soie-sticky-bar-info">' +
        '<span class="soie-sticky-bar-title">SŌIE Silk Pillowcase</span>' +
        '<span class="soie-sticky-bar-price">' + displayPrice + '</span>' +
      '</div>' +
      '<button class="soie-sticky-bar-atc">ADD TO CART</button>';
    document.body.appendChild(bar);

    bar.querySelector('.soie-sticky-bar-atc').addEventListener('click', function () {
      postJSON('/cart/add.js', { items: [{ id: PILLOWCASE_VARIANTS.White, quantity: 1 }] })
        .then(function (resp) {
          var items = resp && resp.items ? resp.items : (Array.isArray(resp) ? resp : []);
          items.forEach(publishAddToCart);
          openDrawer();
        });
    });

    var targetVisible = true;
    var guaranteeVisible = false;

    function updateBar() {
      var show = !targetVisible && !guaranteeVisible;
      bar.style.opacity = show ? '1' : '0';
      bar.style.pointerEvents = show ? 'auto' : 'none';
    }

    var mq = window.matchMedia('(max-width: 768px)');

    function setupObservers() {
      if (!mq.matches) {
        bar.style.opacity = '0';
        bar.style.pointerEvents = 'none';
        return;
      }

      var btnObs = new IntersectionObserver(function (entries) {
        targetVisible = entries[0].isIntersecting;
        updateBar();
      });
      btnObs.observe(target);

      if (guarantee) {
        var gObs = new IntersectionObserver(function (entries) {
          guaranteeVisible = entries[0].isIntersecting;
          updateBar();
        });
        gObs.observe(guarantee);
      }
    }

    setupObservers();
    mq.addEventListener('change', setupObservers);
  }

  /* ── 6. Smooth Scroll ─────────────────────────────────────────── */
  function initSmoothScroll() {
    document.addEventListener('click', function (e) {
      var el = e.target.closest('[data-scroll-to]');
      if (!el) return;
      e.preventDefault();
      var target = document.querySelector(el.dataset.scrollTo);
      if (target) target.scrollIntoView({ behavior: 'smooth' });
    });
  }

  /* ── 7. Countdown helper (used by ship deadline) ──────────────── */
  function formatCountdown(totalSeconds) {
    var h = Math.floor(totalSeconds / 3600);
    var m = Math.floor((totalSeconds % 3600) / 60);
    var s = totalSeconds % 60;
    return (h < 10 ? '0' : '') + h + ':' +
           (m < 10 ? '0' : '') + m + ':' +
           (s < 10 ? '0' : '') + s;
  }

  /* ── 8. Sold Today Counter (Deterministic per day) ──────────── */
  function getSoldTodayCount() {
    /* Deterministic seed based on UTC date so it doesn't change between page loads */
    var now = new Date();
    var dayKey = now.getUTCFullYear() * 10000 + (now.getUTCMonth() + 1) * 100 + now.getUTCDate();
    /* Hash the day key into a base count between 180-340 */
    var hash = ((dayKey * 9301 + 49297) % 233280) / 233280;
    var base = Math.floor(180 + hash * 160);
    /* Add hours-since-midnight * ~8 to make it tick up through the day */
    var hours = now.getUTCHours() + now.getUTCMinutes() / 60;
    var added = Math.floor(hours * 8 + (now.getUTCMinutes() % 7));
    return base + added;
  }

  function initSoldCounter() {
    var count = getSoldTodayCount();
    /* Inject above each ATC button */
    document.querySelectorAll('.soie-atc-btn').forEach(function (btn) {
      if (btn.closest('.soie-cart-drawer')) return;
      var counter = document.createElement('p');
      counter.className = 'soie-sold-today';
      counter.innerHTML = '\uD83D\uDD25 <strong>' + count + '</strong> sold today';
      btn.parentNode.insertBefore(counter, btn);
    });

    /* Tick up every 90-180 seconds */
    function tick() {
      var current = getSoldTodayCount() + Math.floor(Math.random() * 3);
      document.querySelectorAll('.soie-sold-today strong').forEach(function (el) {
        el.textContent = current;
      });
    }
    setInterval(tick, 90000 + Math.random() * 90000);
  }

  /* ── 9. Floating Purchase Notifications ──────────────────────── */
  var NOTIF_NAMES = [
    'Sarah', 'Emma', 'Olivia', 'Sophia', 'Ava', 'Mia', 'Isabella', 'Charlotte',
    'Amelia', 'Harper', 'Lily', 'Chloe', 'Grace', 'Zoe', 'Hannah', 'Maya',
    'Priya', 'Aisha', 'Jess', 'Kate', 'Rachel', 'Nina', 'Lauren', 'Jasmine'
  ];
  var NOTIF_CITIES = [
    'Sydney', 'Melbourne', 'Brisbane', 'Auckland', 'London', 'Manchester',
    'Toronto', 'Vancouver', 'New York', 'Los Angeles', 'Chicago', 'Austin',
    'Seattle', 'Portland', 'Denver', 'Boston', 'Dublin', 'Edinburgh', 'Perth',
    'Wellington', 'San Francisco', 'Miami', 'San Diego', 'Calgary'
  ];
  var NOTIF_PRODUCTS = [
    'SŌIE Silk Pillowcase — Coffee',
    'SŌIE Silk Pillowcase — Grey',
    'SŌIE Silk Pillowcase — Navy',
    'SŌIE Silk Pillowcase — White',
    'SŌIE Silk Sheet Set — Grey',
    'SŌIE Silk Sheet Set — White',
    'The SŌIE Sleep Set — Coffee',
    'The SŌIE Sleep Set — Navy'
  ];

  function pick(arr) { return arr[Math.floor(Math.random() * arr.length)]; }

  function showPurchaseNotif() {
    var name = pick(NOTIF_NAMES);
    var city = pick(NOTIF_CITIES);
    var product = pick(NOTIF_PRODUCTS);
    var minutes = Math.floor(Math.random() * 18) + 2;

    var notif = document.createElement('div');
    notif.className = 'soie-purchase-notif';
    notif.innerHTML =
      '<div class="soie-purchase-notif__icon">\u2713</div>' +
      '<div class="soie-purchase-notif__body">' +
        '<div class="soie-purchase-notif__top"><strong>' + name + '</strong> from ' + city + '</div>' +
        '<div class="soie-purchase-notif__product">just ordered ' + product + '</div>' +
        '<div class="soie-purchase-notif__time">' + minutes + ' minutes ago</div>' +
      '</div>' +
      '<button class="soie-purchase-notif__close" aria-label="dismiss">\u00D7</button>';
    document.body.appendChild(notif);

    /* Force layout then add visible class */
    requestAnimationFrame(function () { notif.classList.add('visible'); });

    var hideTimer = setTimeout(function () { hide(); }, 6000);
    function hide() {
      clearTimeout(hideTimer);
      notif.classList.remove('visible');
      setTimeout(function () { notif.remove(); }, 400);
    }
    notif.querySelector('.soie-purchase-notif__close').addEventListener('click', hide);
  }

  function initPurchaseNotifs() {
    /* Wait 8s after page load before first notification */
    setTimeout(function () {
      showPurchaseNotif();
      var counter = 0;
      function loop() {
        var delay = 18000 + Math.random() * 14000;
        setTimeout(function () {
          counter++;
          /* Every 3rd notification is a review instead of a purchase */
          if (counter % 3 === 0 && typeof showReviewNotif === 'function') {
            showReviewNotif();
          } else {
            showPurchaseNotif();
          }
          loop();
        }, delay);
      }
      loop();
    }, 8000);
  }

  /* ── 10. Variant Scarcity Tags (deterministic per day) ───────── */
  function dayHash(seed) {
    var now = new Date();
    var key = now.getUTCFullYear() * 10000 + (now.getUTCMonth() + 1) * 100 + now.getUTCDate();
    return ((key * (seed || 9301) + 49297) % 233280) / 233280;
  }

  function initScarcityTags() {
    /* Pick ONE color per product to mark as "selling fast" — deterministic per day */
    document.querySelectorAll('.soie-swatches').forEach(function (group) {
      var swatches = group.querySelectorAll('.soie-swatch');
      if (swatches.length === 0) return;
      var product = swatches[0].dataset.product || 'x';

      /* Hash to pick a single swatch */
      var idx = Math.floor(dayHash(product.charCodeAt(0) * 11) * swatches.length);
      var swatch = swatches[idx];
      if (!swatch || swatch.querySelector('.soie-scarcity-tag')) return;

      var tag = document.createElement('span');
      tag.className = 'soie-scarcity-tag';
      tag.textContent = 'LOW STOCK';
      swatch.style.position = 'relative';
      swatch.appendChild(tag);
    });
  }

  /* ── 11. Order-By-Time Shipping Deadline ─────────────────────── */
  function getSecondsUntilShipCutoff() {
    /* Cutoff at 16:00 UTC each day */
    var now = new Date();
    var cutoff = new Date(Date.UTC(
      now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), 16, 0, 0, 0
    ));
    if (cutoff <= now) {
      cutoff.setUTCDate(cutoff.getUTCDate() + 1);
    }
    return Math.max(0, Math.floor((cutoff - now) / 1000));
  }

  function initShipDeadline() {
    document.querySelectorAll('.soie-atc-btn').forEach(function (btn) {
      if (btn.closest('.soie-cart-drawer')) return;
      var line = document.createElement('p');
      line.className = 'soie-ship-deadline';
      line.innerHTML = '\uD83D\uDE9A Order in <strong data-ship-countdown>00:00:00</strong> to ship today';
      var urgencyEl = btn.parentNode.querySelector('.soie-atc-urgency');
      if (urgencyEl) urgencyEl.parentNode.insertBefore(line, urgencyEl.nextSibling);
      else btn.parentNode.insertBefore(line, btn.nextSibling);
    });

    function tick() {
      var secs = getSecondsUntilShipCutoff();
      var formatted = formatCountdown(secs);
      document.querySelectorAll('[data-ship-countdown]').forEach(function (el) {
        el.textContent = formatted;
      });
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ── 12. Live Viewer Count ───────────────────────────────────── */
  function initViewerCount() {
    /* Pseudo-random base 8-25, fluctuates every 12-25 seconds */
    var base = 8 + Math.floor(dayHash(31) * 17);
    var current = base;

    var badge = document.createElement('div');
    badge.className = 'soie-viewer-badge';
    badge.innerHTML = '\uD83D\uDC41 <strong>' + current + '</strong> people viewing this right now';

    /* Inject into hero info column */
    var heroInfo = document.querySelector('.soie-landing-hero__info');
    if (heroInfo) {
      var firstChild = heroInfo.querySelector('.soie-eyebrow') || heroInfo.firstChild;
      heroInfo.insertBefore(badge, firstChild);
    } else {
      document.body.appendChild(badge);
    }

    function fluctuate() {
      var delta = Math.floor(Math.random() * 5) - 2;
      current = Math.max(6, Math.min(28, current + delta));
      var el = badge.querySelector('strong');
      if (el) el.textContent = current;
    }
    setInterval(fluctuate, 12000 + Math.random() * 13000);
  }

  /* ── 13. Cart Reservation Timer ──────────────────────────────── */
  var cartReservationStarted = null;

  function startCartReservation() {
    cartReservationStarted = Date.now();
  }

  function injectCartReservation() {
    if (!drawer || !cartReservationStarted) return;
    var existing = drawer.querySelector('.soie-cart-reservation');
    if (existing) return;
    var header = drawer.querySelector('.soie-cart-header');
    if (!header) return;
    var banner = document.createElement('div');
    banner.className = 'soie-cart-reservation';
    banner.innerHTML = '\uD83D\uDD12 Reserved for <strong data-reservation>10:00</strong>';
    header.insertAdjacentElement('afterend', banner);

    function tick() {
      var elapsed = Math.floor((Date.now() - cartReservationStarted) / 1000);
      var remaining = Math.max(0, 600 - elapsed);
      var m = Math.floor(remaining / 60);
      var s = remaining % 60;
      var formatted = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
      var el = banner.querySelector('[data-reservation]');
      if (el) el.textContent = formatted;
      if (remaining === 0) {
        banner.innerHTML = '\u26A0 Your reservation has expired';
        return;
      }
      setTimeout(tick, 1000);
    }
    tick();
  }

  /* ── 14. Exit Intent Popup ───────────────────────────────────── */
  function initExitIntent() {
    if (sessionStorage.getItem('soie-exit-shown')) return;
    var fired = false;

    function showPopup() {
      if (fired) return;
      fired = true;
      sessionStorage.setItem('soie-exit-shown', '1');

      var overlay = document.createElement('div');
      overlay.className = 'soie-exit-overlay';
      var modal = document.createElement('div');
      modal.className = 'soie-exit-modal';
      modal.innerHTML =
        '<button class="soie-exit-close" aria-label="close">\u00D7</button>' +
        '<p class="soie-eyebrow" style="color:var(--soie-cta);text-align:center;margin-bottom:12px">WAIT</p>' +
        '<h3 class="soie-headline-section" style="text-align:center;font-style:normal;margin:0 0 12px">Don\u2019t leave empty handed.</h3>' +
        '<p style="text-align:center;color:var(--soie-grey);font-size:14px;line-height:1.6;margin-bottom:24px">Get an extra <strong style="color:var(--soie-cta)">10% off</strong> if you order in the next 10 minutes.</p>' +
        '<div class="soie-exit-code">WAIT10</div>' +
        '<button class="soie-exit-cta">CLAIM 10% OFF</button>' +
        '<p style="text-align:center;color:var(--soie-grey);font-size:11px;margin-top:12px">Code auto-applies at checkout</p>';
      overlay.appendChild(modal);
      document.body.appendChild(overlay);
      requestAnimationFrame(function () { overlay.classList.add('visible'); });

      function close() {
        overlay.classList.remove('visible');
        setTimeout(function () { overlay.remove(); }, 300);
      }
      overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
      modal.querySelector('.soie-exit-close').addEventListener('click', close);
      modal.querySelector('.soie-exit-cta').addEventListener('click', function () {
        window.location.href = '/discount/WAIT10?redirect=/pages/sleep-upgrade';
      });
    }

    /* Desktop: mouse leaving top of viewport */
    document.addEventListener('mouseout', function (e) {
      if (e.clientY <= 0 && !e.relatedTarget) showPopup();
    });

    /* Mobile: trigger after 25 seconds + scroll back up */
    if (window.matchMedia('(max-width: 768px)').matches) {
      var lastScroll = window.scrollY;
      var startTime = Date.now();
      window.addEventListener('scroll', function () {
        var now = window.scrollY;
        if (Date.now() - startTime > 25000 && now < lastScroll - 100) {
          showPopup();
        }
        lastScroll = now;
      });
    }
  }

  /* ── 15. Bestseller Badges ───────────────────────────────────── */
  function initBestsellerBadges() {
    var heroInfo = document.querySelector('.soie-landing-hero__info');
    if (heroInfo) {
      var badge = document.createElement('span');
      badge.className = 'soie-bestseller-badge';
      badge.textContent = '\u2605 TIKTOK FAVORITE';
      var eyebrow = heroInfo.querySelector('.soie-eyebrow');
      if (eyebrow) eyebrow.parentNode.insertBefore(badge, eyebrow);
    }

    /* MOST LOVED tag on the upgrade block */
    var upgradeText = document.querySelector('.soie-upgrade__text');
    if (upgradeText) {
      var badge2 = document.createElement('span');
      badge2.className = 'soie-bestseller-badge soie-bestseller-badge--alt';
      badge2.textContent = '\u2605 EDITOR\u2019S PICK';
      var eyebrow2 = upgradeText.querySelector('.soie-eyebrow');
      if (eyebrow2) eyebrow2.parentNode.insertBefore(badge2, eyebrow2);
    }
  }

  /* ── 16. Recent Reviews Mixed into Toast Notifications ───────── */
  var REVIEW_SNIPPETS = [
    { text: 'My skin has never looked better.', author: 'Maya T.' },
    { text: 'Worth every penny — my hair is unreal.', author: 'Jess K.' },
    { text: 'Best purchase I\u2019ve made all year.', author: 'Rachel L.' },
    { text: 'No more pillow creases. Game changer.', author: 'Priya M.' },
    { text: 'Soft, luxurious, exactly as advertised.', author: 'Chloe W.' },
    { text: 'My dermatologist asked what I changed.', author: 'Sarah N.' },
    { text: 'I bought one. Now I have three.', author: 'Olivia G.' }
  ];

  function showReviewNotif() {
    var review = pick(REVIEW_SNIPPETS);
    var hours = Math.floor(Math.random() * 11) + 1;

    var notif = document.createElement('div');
    notif.className = 'soie-purchase-notif soie-review-notif';
    notif.innerHTML =
      '<div class="soie-purchase-notif__icon" style="background:var(--soie-cta)">\u2605</div>' +
      '<div class="soie-purchase-notif__body">' +
        '<div class="soie-purchase-notif__top">\u2605\u2605\u2605\u2605\u2605</div>' +
        '<div class="soie-purchase-notif__product" style="white-space:normal;font-style:italic">\u201C' + review.text + '\u201D</div>' +
        '<div class="soie-purchase-notif__time">\u2014 ' + review.author + ' \u00B7 ' + hours + ' hours ago</div>' +
      '</div>' +
      '<button class="soie-purchase-notif__close" aria-label="dismiss">\u00D7</button>';
    document.body.appendChild(notif);
    requestAnimationFrame(function () { notif.classList.add('visible'); });

    var hideTimer = setTimeout(function () { hide(); }, 7000);
    function hide() {
      clearTimeout(hideTimer);
      notif.classList.remove('visible');
      setTimeout(function () { notif.remove(); }, 400);
    }
    notif.querySelector('.soie-purchase-notif__close').addEventListener('click', hide);
  }

  /* ── 17. Recently Restocked Indicator ────────────────────────── */
  function initRestockBadge() {
    var heroInfo = document.querySelector('.soie-landing-hero__info');
    if (!heroInfo) return;
    var swatches = heroInfo.querySelector('.soie-swatches');
    if (!swatches) return;

    var note = document.createElement('p');
    note.className = 'soie-restock-note';
    note.innerHTML = '\u21BB Restocked 2 days ago \u2014 selling fast';
    swatches.parentNode.insertBefore(note, swatches.nextSibling);
  }

  /* ── Init ──────────────────────────────────────────────────────── */
  function init() {
    initSwatches();
    initATC();
    initStickyBar();
    initSmoothScroll();
    initSoldCounter();
    initPurchaseNotifs();
    initScarcityTags();
    initShipDeadline();
    initViewerCount();
    initExitIntent();
    initBestsellerBadges();
    initRestockBadge();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
